import { render } from "./TheLocationDetails.vue?vue&type=template&id=59397b32"
import script from "./TheLocationDetails.vue?vue&type=script&lang=js"
export * from "./TheLocationDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__